<template>
  <div class="margins">
    <div @click="openLink(config.link)" data-growing-container>
      <image-with-loading
        :src="'https://m2.ikea.cn/' + config.image.url"
        :width="config.image.width"
        :height="config.image.height"
      />
    </div>
    <div class="products" style="flex-wrap:wrap" v-if="products.length > 0">
      <div
        class="product flex-left-align"
        v-for="(product, index) in products"
        @click="viewProduct(product)"
        data-growing-container
        :data-growing-idx="product.id"
      >
        <div class="img">
          <image-with-loading
            :src="product.image"
            :width="48"
            :height="48"/>
        </div>
        <div class="detail">
          <div class="labels" v-if="product.priceDisplay.tags">
            <div v-for="tag in product.priceDisplay.tags" :style="{color: '#' + tag.colorHex}">{{tag.name}}</div>
          </div>
          <div class="flex-space-between">
            <div>
              <div class="name">{{product.name}}</div>
              <div class="desc">{{product.fullDescription || product.productType || ' '}}</div>
            </div>
            <div style="flex-shrink: 0; margin-left: 10px; text-align: right">
              <div :style="{color: '#' + product.priceDisplay.currentPriceColorHex}" class="price">
                ￥ {{formatPrice(product.priceDisplay.currentPrice)}}
                {{product.priceDisplay.priceUnit ? '/' + product.priceDisplay.priceUnit : ''}}
              </div>
              <div class="desc" :style="{color: '#' + product.priceDisplay.originalPriceColorHex}"
                   v-if="product.priceDisplay.originalPrice">
                {{product.priceDisplay.originalPriceTooltip ? '(' + product.priceDisplay.originalPriceTooltip + ')': ''}}
                <span :class="{'line-through': product.priceDisplay.originalPriceLineThrough}">
                  ￥ {{formatPrice(product.priceDisplay.originalPrice)}}
                  {{product.priceDisplay.priceUnit ? '/' + product.priceDisplay.priceUnit : ''}}</span>
              </div>
            </div>
          </div>
          <div
            class="desc"
            v-if="product.priceDisplay.promotionDescription"
          >{{product.priceDisplay.promotionDescription}}</div>
        </div>
      </div>
    </div>

    <div v-if="config.text" class="text" v-html="config.text"></div>
  </div>
</template>

<script>
import ImageWithLoading from "@/components/ImageWithLoading";
const router = require("@/libs/router");
import mbff from "@/libs/mbff"
const utils = require("@/libs/utils");

export default {
  components: {
    ImageWithLoading
  },
  props: ["config"],
  data() {
    return {
      products: []
    };
  },
  mounted() {
    const hasProducts = this.config.products && this.config.products.length > 0;
    if (!hasProducts) {
      return;
    }
    var self = this;
    mbff
      .get(`/content/products?ids=${this.config.products.join(",")}`)
      .then(function(response) {
        self.products = response.data;
      });
  },
  methods: {
    openLink(link) {
      router.open("link", {
        link: link
      });
    },
    viewProduct(product) {
      router.open("product", {
        id: product.id,
        type: product.itemType,
        seriesId: product.seriesId
      });
    },
    formatPrice(price) {
      return utils.formatPrice(price)
    }
  }
};
</script>

<style scoped>
.margins {
  padding: 0px 20px;
}

.products {
  /*margin-top: 10px;*/
}
.product {
  background-color: #f5f5f5;
  padding: 10px;
  align-items: flex-start;
  margin-top: 5px;
}
.product .img {
  padding: 5px;
  background-color: white;
  border-radius: 6px;
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}
.product .detail {
  margin-left: 10px;
  width: 100%;
  font-size: 12px;
}
.product .labels {
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 3px;
  font-weight: bold;
}
.product .labels div {
  border-radius: 4px;
  margin-right: 10px;
}
.product .name {
  font-size: 12px;
  font-weight: bold;
}

.product .desc {
  font-size: 12px;
  color: #666666;
}

.product .price {
  font-weight: bold;
}

.text {
  margin: 10px 0px;
}
.breath-taking {
  background: #ffd800;
  padding: 1px 6px;
  margin-right: 5px;
  -webkit-box-shadow: 2px 2px 0 0 #ef4123;
  box-shadow: 2px 2px 0 0 #ef4123;
}

.labels {
  /* height: 14px; */
  font-weight: bold;
  font-size: 12px;
  margin-right: 3px;
}
.nlp-label {
  color: rgb(237, 2, 42);
}
.new-label {
  color: rgb(202, 80, 8);
}
.family-label {
  color: rgb(0, 110, 200);
}
.line-through {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/ImageTextComponent.vue